export class LoginModel{
    countryCode: string;
    loginType: string;
    phoneNumber: string;
    email: string;
    pin: string;
    otpCode: string;
    refNo: string;

    constructor(countryCode: string,
        loginType: string,
        phoneNumber: string,
        email: string,
        pin: string,
        otpCode: string,
        refNo: string) {
            this.countryCode = countryCode;
            this.loginType = loginType;
            this.phoneNumber = phoneNumber;
            this.email = email;
            this.pin = pin;
            this.otpCode = otpCode;
            this.refNo = refNo;
    }
}